import {DeprecatedDataFrame, IsMaskedDataRow} from 'data-frames/DataFrameTypes';

import filterRows from './filterRows';
import {hasOptionalColumn} from './hasColumn';

/**
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function filterMaskedRows<TDataRow extends IsMaskedDataRow>(
  dataFrame: DeprecatedDataFrame<TDataRow>
): DeprecatedDataFrame<TDataRow> {
  return hasOptionalColumn(dataFrame, 'isMasked') ? filterRows(dataFrame, (row) => !row.isMasked) : dataFrame;
}
